<template>
  <div class="china">
    <div class="main-title">
      <h3>中国高校专利地域分布</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">色块颜色的深浅代表该区域所有高校专利有效量的大小，鼠标移动到该区域会显示具体的数值，黄色光圈标识数据前五的区域({{yearRange}})</div>
      </div>
    </div>
    <div class="charts map-bg">
      <Map mapType="china" :isMobile="isMobile"></Map>
    </div>
    <div class="main-title">
      <h3>中国高校专利申请/授权/有效量TOP10</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">以申请量作为排名标准{{yearRange}}</div>
      </div>
    </div>
    <div class="charts-table  charts">
      <table>
        <tr>
          <th>排名</th>
          <th>高校</th>
          <th>申请量</th>
          <th>授权量</th>
          <th>有效量</th>
        </tr>
        <tr v-for="(item,index) in tableData" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.name}}</td>
          <td>{{item.applications}}</td>
          <td>{{item.grant}}</td>
          <td>{{item.ed}}</td>
        </tr>
      </table>
    </div>
    <div class="main-title">
      <h3>中国高校近五年专利情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">中国高校专利近五年发明申请公开量、发明授权量、实用新型公开量、外观设计公开量、PCT申请公开量</div>
      </div>
    </div>
    <div class="charts">
      <TimeLineBarPie :type="11" :isMobile="isMobile" tabType="china"></TimeLineBarPie>
    </div>
    <!--<div class="main-title">
      <h3>中国内地主要城市高校平均专利数据</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">北上广深四个城市高校专利发明申请公开量除以高校个数、发明授权量除以高校个数（近五年2016-2020）</div>
      </div>
    </div>
    <div class="charts">
      <Echarts height="500px" :option="lineOption"></Echarts>
    </div>-->
    <div class="main-title">
      <h3>中国内地主要城市高校专利申请技术领域及产业分布</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">北上广深四个城市高校专利申请公开量在战略性新兴产业分类下的一级分类前五({{yearRange}})</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :height="isMobile?'250px':'500px'" :option="scatter"></Echarts>
    </div>
  </div>
</template>

<script>
import Map from '@/components/Map'
import Echarts from '@/components/Echarts'
import TimeLineBarPie from '@/components/TimeLineBarPie'
import Query from '@/utils/query'

export default {
  name: "China",
  data() {
    return {
      barPie: '',
      lineOption: {},
      scatter: {},
      tableData: [],
      isMobile: false
    }
  },
  mixins: [Query],
  props: {},
  components: {Map, Echarts, TimeLineBarPie},
  methods: {
    getTableList() {
      this.getAjax(10, data => {
        this.tableData = data
      })
    },
    getLineOption() {
      this.lineOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          textStyle: {
            fontSize: 16
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: ['北京', '上海', '广州', '深圳'],
          axisLabel: {
            fontSize: 16
          }
        },
        series: [
          {
            name: '校均发明申请',
            type: 'bar',
            data: [30, 45, 40, 68]
          },
          {
            name: '校均发明授权',
            type: 'bar',
            data: [70, 80, 90, 105]
          }
        ]
      }
    },
    getScatter() {
      this.getAjax(12, data => {
        let xAxis = []
        let temp = []
        // let shangHai = []
        for (let key in data) {
          xAxis.push(key)
          temp.push(data[key])
        }
        const maxX = 20000
        this.scatter = {
          tooltip: {
            /*formatter: function (params) {
            }*/
          },
          legend: {
            top: 10,
            data: ['北京', '上海', '广州', '深圳'],
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?7:14,
            itemHeight: this.isMobile?7:14
          },
          xAxis: {
            data: xAxis,
            axisLabel: {
              fontSize: this.isMobile?8:16,
              formatter: (label) => {
                let str = label
                if (!this.isMobile && label.length > 8) {
                  str = label.match(/.{1,8}/g).join('\n')
                }
                if (this.isMobile && label.length > 4) {
                  str = label.match(/.{1,4}/g).join('\n')
                }
                return str
              }
            }
          },
          grid: {
            left: this.isMobile?45:80,
            right: this.isMobile?0:60,
            bottom: '80px',
          },
          yAxis: {
            axisLabel: {
              fontSize: this.isMobile?8:14
            }
          },
          series: [
            {
              name: '北京',
              type: 'scatter',
              // data: [[0, 10000], [1, 8000], [2, 5000], [3, 18000], [4, 13000]],
              data: this.getScatterCity(temp, '北京市'),
              symbolSize: (data => {
                return this._symbolSize(data, maxX)
              })
            },
            {
              name: '上海',
              type: 'scatter',
              data: this.getScatterCity(temp, '上海市'),
              symbolSize: (data => {
                return this._symbolSize(data, maxX)
              })
            },
            {
              name: '广州',
              type: 'scatter',
              data: this.getScatterCity(temp, '广州市'),
              symbolSize: (data => {
                return this._symbolSize(data, maxX)
              })
            },
            {
              name: '深圳',
              type: 'scatter',
              data: this.getScatterCity(temp, '深圳市'),
              symbolSize: (data => {
                return this._symbolSize(data, maxX)
              })
            }
          ]
        }
      })
    },
    getScatterCity(data, city) {
      let temp = []
      data && data.forEach((item, i) => {
        temp.push([i, item[city]])
      })
      return temp
    },
    _symbolSize(data, maxX) {
      let size = 10
      size = Math.floor((Math.log(1 + (data[1] / maxX) * 10) / Math.log(10)) * 40)
      size = size < 10 ? 10 : size
      size = data[2] === 0 ? 0 : size
      return size
    }
  },
  computed: {},
  created(){
    // 判断是否移动端
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
  mounted() {
    this.getLineOption()
    this.getScatter()
    this.getTableList()
  }
}
</script>
